<template>
  <section class="disclaimer">
      <div class="disclaimer__content container">
				<button @click="openText()" class="disclaimer__content--button">
					<span>Disclaimer</span>
					<img :class="{ 'rotate': isOpen === true }" src="~@/assets/root/dropdown-icon.svg" alt="Arrow icon">
				</button>
				<div v-show="isOpen" class="disclaimer__content--text">
					<p>
					Lorem ipsum dolor sit amet consectetur, adipisicing 
					elit. Dolores nesciunt impedit quae modi quod rerum 
					aliquid pariatur eveniet, blanditiis fuga vero repudiandae 
					minima, sunt accusamus eos voluptas dolorem voluptate totam.
					</p>
					<p>
					Lorem ipsum dolor sit amet consectetur, adipisicing 
					elit. Dolores nesciunt impedit quae modi quod rerum 
					aliquid pariatur eveniet, blanditiis fuga vero repudiandae 
					minima, sunt accusamus eos voluptas dolorem voluptate totam.
					</p>
					<p>
					Lorem ipsum dolor sit amet consectetur, adipisicing 
					elit. Dolores nesciunt impedit quae modi quod rerum 
					aliquid pariatur eveniet, blanditiis fuga vero repudiandae 
					minima, sunt accusamus eos voluptas dolorem voluptate totam.
					</p>
				</div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Disclaimer',
  data () {
    return {
			isOpen: false
    }
  },
	methods: {
		openText() {
			this.isOpen = !this.isOpen;
			return this.isOpen;
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/disclaimer.scss";
</style>
